<div
    *ngIf="isVisible"
    [ngClass]="{'error': msg?.type === MESSAGE_TYPE.INFO || msg?.type === MESSAGE_TYPE.APP_SUCCESS }"
    class="notification"
>
    <div [ngStyle]="{ 'width': lineWidth + '%' }" class="notification__line-time"></div>

    <button (click)="closeMessage()" class="notification__close">
        <i class="pi pi-times icon"></i>
    </button>

    <div class="notification__content">
        <span class="notification__content__title">
            <ng-container *ngIf="msg?.type === MESSAGE_TYPE.INFO || msg?.type === MESSAGE_TYPE.APP_SUCCESS; else otherTypeNotification">
                <span
                    *ngIf="msg?.driverId; else noDriver"
                    [routerLink]="['/panel' , 'driver']"
                    [queryParams]="{mode:'details', id: msg!.driverId}"
                >
                    {{ driverName }}
                </span>
                <ng-template #noDriver>
                    {{'events-list.unknown-driver'|translate}}
                </ng-template>
                &#8226; 
                <span
                    *ngIf="msg?.vehicleId"
                    (click)="openVehicle(msg!.vehicleId!)"
                >
                    {{ vehicleName }}
                </span>
            </ng-container>

            <ng-template #otherTypeNotification>
                {{msg?.title}}
            </ng-template>
        </span>

        <p class="notification__content__desc">
            {{ (msg?.type === MESSAGE_TYPE.INFO || msg?.type === MESSAGE_TYPE.APP_SUCCESS) ? msg?.title : msg?.text }}
        </p>
    </div>
</div>
